<template>
   <div>
       <el-button  type="primary"
                   size="mini" @click="showFileSelect">{{buttonText}}</el-button>
       <el-dialog center v-if="show" title="选择文件" :visible.sync="show" append-to-body>
               <el-form  :inline="true"  size="mini">
                   <el-form-item>
                       <el-input
                           clearable
                           @keyup.enter.native="getSearch()"
                           style="width: 200px;margin-right: 20px;"
                           class="filter-item"
                           placeholder="搜索文件"
                           size="small"
                           v-model="listQuery.keyword"
                       ></el-input>
                   </el-form-item>
                   <el-form-item>
                       <el-select
                           class="filter-item"
                           v-model="listQuery.type"
                           placeholder="文件类型"
                           size="small"
                           style="margin-right: 20px"
                           clearable
                       >
                           <el-option key="0"  label="文本" value="0"></el-option>
                           <el-option key="1"  label="音频" value="1"></el-option>
                           <el-option key="2"  label="图片" value="2"></el-option>
                           <el-option key="3"  label="视频" value="3"></el-option>
                       </el-select>
                   </el-form-item>

                   <el-form-item>
                       <el-select v-model="listQuery.tagIds"
                                  clearable

                                  multiple placeholder="选择标签">
                           <el-option
                               v-for="item in tagList"
                               :key="item.key"
                               :label="item.value"
                               :value="item.key">
                           </el-option>
                       </el-select>
                   </el-form-item>

                   <el-form-item>
                       <el-input
                           clearable
                           @keyup.enter.native="getSearch"
                           style="width: 220px;margin-right: 20px;"
                           class="filter-item"
                           placeholder="作者id"
                           size="small"
                           v-model="listQuery.authorId"
                       ></el-input>
                   </el-form-item>
                   <el-form-item>
                       <el-select
                           class="filter-item"
                           v-model="listQuery.sourceType"
                           placeholder="来源"
                           size="small"
                           style="margin-right: 20px"
                           clearable
                       >
                           <el-option key="0"  label="后台上传" value="0"></el-option>
                           <el-option key="1"  label="用户任务" value="1"></el-option>

                       </el-select>
                   </el-form-item>
                   <el-form-item>
                       <el-input
                           clearable
                           @keyup.enter.native="getSearch"
                           style="width: 220px;margin-right: 20px;"
                           class="filter-item"
                           placeholder="来源id"
                           size="small"
                           v-model="listQuery.sourceId"
                       ></el-input>
                   </el-form-item>
                   <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
               </el-form>
         <div style="margin-top: 10px;margin-bottom: 20px">
           <el-breadcrumb separator="/">
             <el-breadcrumb-item><a @click="changeCategory('0')">全部</a></el-breadcrumb-item>
             <el-breadcrumb-item v-for="item in parentsCategory"><a @click="changeCategory(item.id)">{{item.name}}</a></el-breadcrumb-item>
           </el-breadcrumb>
         </div>
         <el-button
             class="filter-item"
             type="primary"
             size="mini"
             icon="el-icon-circle-plus"
             @click="addDir"
         >新建目录
         </el-button>
           <el-button
               class="filter-item"
               type="primary"
               size="mini"
               icon="el-icon-circle-plus"
               @click="add"
           >上传文件
           </el-button>
           <el-row  v-for="(r, rowIdx) in list.length" v-if="rowIdx % 5 === 0" style="margin-top: 20px">
               <el-col :span="4" v-for="(c, colIdx) in  5" v-if="colIdx + rowIdx < list.length" :key="colIdx"
                       :style="colIdx !== 0 ? 'margin-left:20px;':''">
                   <el-card   :class="'cus-shadow' + (inList(selectedItems,list[colIdx + rowIdx].id) !== -1  ? ' selected-shadow':' ')" :body-style="{ padding: '0px' }">
                      <div @click="selectItem(list[colIdx + rowIdx])" >
                          <div v-if="inList(selectedItems,list[colIdx + rowIdx].id) === -1 && size <= selectedItems.length" class="disabled">

                          </div>
                          <div  style="height: 120px;width: 100%">
                              <div style="width: 100%;height: 100px;font-size: 12px;padding: 10px"
                                   v-if="list[colIdx + rowIdx].type === 0">
                                  {{ list[colIdx + rowIdx].content }}
                              </div>
                              <el-image v-if="list[colIdx + rowIdx].type === 2" style="width: 100%;height: 120px" fit="cover"
                                        :src="list[colIdx + rowIdx].content" class="image">
                              </el-image>
                            <div v-if="list[colIdx + rowIdx].type === -1" style="padding: 10px;height: 150px">
                              <el-image  style="width: 100%;height: 120px" fit="cover"
                                         src="https://oss.lifeinmark.com/icon/%E9%BB%98%E8%AE%A4%E6%96%87%E4%BB%B6%E5%A4%B9.png" class="image">
                              </el-image>
                            </div>
                              <video-player
                                  v-if="list[colIdx + rowIdx].type === 3"
                                  class="video-player vjs-custom-skin"
                                  ref="videoPlayer"
                                  :playsinline="true"
                                  :options="list[colIdx + rowIdx].content"
                              ></video-player>
                          </div>
                          <div style="padding: 14px;width: 100%">
                              <div style="font-size: 16px; font-weight: 600">
                                  <span>{{ list[colIdx + rowIdx].name }}</span>
                              </div>
                              <div v-if="list[colIdx + rowIdx].type !== -1" style="color: #3a3a3a; font-size: 12px;padding-top: 5px">
                                  form:<span style="color: #1e90fb">{{ list[colIdx + rowIdx].author}}</span>
                              </div>
                              <div v-if="list[colIdx + rowIdx].type !== -1" style="padding-top: 10px">
                                  <el-tag style="margin-right: 5px" type="success" v-for="tag in list[colIdx + rowIdx].fileTags" @close="delTag(list[colIdx + rowIdx].id,tag.id)" size="mini">{{tag.name}}</el-tag>
                              </div>
                              <div v-if="list[colIdx + rowIdx].type !== -1" class="bottom clearfix">
                                  <el-button type="text" size="mini" class="button" @click="viewFile(list[colIdx + rowIdx].type, list[colIdx + rowIdx].content)">预览</el-button>
<!--                                  <el-button type="text" size="mini" @click="delCard(list[colIdx + rowIdx].id)" style="color: rgba(255,0,0,0.75);" class="danger">删除</el-button>-->
                              </div>
                          </div>
                      </div>
                   </el-card>
               </el-col>
           </el-row>
           <!-- 页码 -->
           <template slot="footer">
               <el-pagination
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page.sync="listQuery.currentPage"
                   :page-sizes="[10,20,30, 50]"
                   :page-size="listQuery.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="total"
               ></el-pagination>
           </template>
           <el-dialog title="预览" :visible.sync="viewFileShow" append-to-body>
               <view-file :type="viewFileType" :content="viewFileContent"></view-file>
           </el-dialog>
           <el-dialog show-close center title="上传文件"  :visible.sync="fileEditShow" append-to-body>
               <file-edit-bat v-if="fileEditShow" :category-id="listQuery.categoryId" @close-dialog="closeFileEdit"></file-edit-bat>
           </el-dialog>
           <el-dialog show-close center title="添加标签"  :visible.sync="addTagShow" append-to-body>
               <el-form>
                   <el-form label="选择标签">
                       <el-select v-model="selectedTags"
                                  clearable

                                  multiple placeholder="选择标签">
                           <el-option
                               v-for="item in addTagList"
                               :key="item.key"
                               :disabled="item.disable"
                               :label="item.value"
                               :value="item.key">
                           </el-option>
                       </el-select>
                   </el-form>
                   <div style="margin-top: 20px">
                       <el-button @click="()=>{
                   addTagShow = false
               }">取 消</el-button>
                       <el-button type="success" @click="submitAddTag()">确定</el-button>
                   </div>
               </el-form>

           </el-dialog>
           <div class="footer">
               <el-button @click="()=>show=false">取 消</el-button>
               <el-button type="success" @click="confirm('form')">确定</el-button>
           </div>
       </el-dialog>
     <el-dialog show-close center title="新建目录"  :visible.sync="addDirShow">
       <el-form :model="dirForm" ref="form" label-width="80px">
         <el-form-item label="名称" prop="name">
           <el-input v-model="dirForm.name" placeholder="输入名称" :clearable="true"></el-input>
         </el-form-item>
         <el-form-item>
           <div class="footer">
             <el-button @click="addDirShow = false">取 消</el-button>
             <el-button type="success" @click="addDirConfirm">确定</el-button>
           </div>
         </el-form-item>
       </el-form>
     </el-dialog>
   </div>
</template>
<script>

import { getUserTagList, removeUserTag } from '@/api/demo/user'
import {
  addFileCategory,
  addResourceTag,
  delFileResource,
  delResourceTag,
  fileCategoryOptions, fileCategoryParents,
  fileResourceList,
  fileTagOption
} from '@/api/demo/file'
import viewFile from '@/components/file/viewFile.vue'
import fileEditBat from '@/pages/demo/file/resource/editBat.vue'
import { functions } from 'lodash/object'
import { inList } from '@/utils'
import it from 'element-ui/src/locale/lang/it'
export default {
  name: 'fileResource',
  components: {
    viewFile,
    fileEditBat
  },
  props: {
    size: {
      type: Number,
      default: 1
    },
    buttonText: {
      type: String,
      default: '资源库选择'
    },
    value: {
      type: Array | String,
      default: []
    },
    valueType: { // 返回值的类型
      type: String,
      default: 'content' // id / content
    },
    fileType: { // 为空则全部
      type: Number,
      default: null
    },
    defaultDirId: {
      type: String,
      default: '0'
    }

  },
  data () {
    return {
      addDirShow: false,
      parentsCategory: [],
      dirForm: {
        name: '', // 名称
        pid: '' // 父 id
      },
      data: this.value,
      selectedItems: [],
      show: false,
      addTagShow: false,
      addTagFileId: '',
      selectedTags: [],
      addTagList: [],
      tagList: [],
      categoryList: [],
      viewFileShow: false,
      fileEditShow: false,
      viewFileType: 0,
      viewFileContent: '',
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      list: [],
      form: {
        color: '', // 名称
        word: '' // 文件
      },
      listQuery: {
        categoryId: '0',
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '文件',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    if (this.fileType) {
      this.listQuery.type = this.fileType
    }
  },
  watch: {
    value (newVal) {
      this.data = newVal
      console.log('newVal---', newVal)
      if (this.valueType === 'id') {
        newVal.forEach(item => {
          this.selectedItems.push({ id: item })
        })
      }
    },
    defaultDirId (newVal) {
      this.changeCategory(newVal)
    }
  },
  methods: {
    inList,
    functions,
    selectItem (item) {
      if (item.type === -1) {
        this.changeCategory(item.id)
        return
      }
      let idx = inList(this.selectedItems, item.id)
      if (idx !== -1) {
        this.selectedItems.splice(idx)
      } else {
        if (this.size <= this.selectedItems.length) {
          return
        }
        this.selectedItems.push(item)
      }
    },
    showFileSelect () {
      this.show = true
      this.initFileSelect()
    },
    initFileSelect () {
      this.changeCategory(this.defaultDirId)
      fileTagOption().then(res => {
        this.tagList = res
      })
      fileCategoryOptions().then(res => {
        this.categoryList = res
      })
    },
    changeCategory (id) {
      console.log('id', id)
      this.listQuery.categoryId = id
      fileCategoryParents(id).then(res => {
        this.parentsCategory = res
      })
      this.getSearch()
    },
    addTag (fileId, tags) {
      this.addTagFileId = fileId
      this.addTagShow = true
      this.addTagList = JSON.parse(JSON.stringify(this.tagList))
      for (let i = 0; i < this.addTagList.length; i++) {
        let item = this.addTagList[i]
        console.log('tags', tags)
        if (inList(tags, item.key) >= 0) {
          item.disable = true
        }
      }
      console.log('addTagList', this.addTagList)
    },
    submitAddTag () {
      if (this.selectedTags.length === 0) {
        this.$message({
          message: '未选择标签',
          type: 'error',
          center: true
        })
        return
      }
      let that = this
      addResourceTag(this.addTagFileId, this.selectedTags).then(res => {
        that.$message({
          message: '添加成功',
          type: 'success',
          center: true
        })
        that.addTagShow = false
        that.getSearch()
      })
    },
    confirm () {
      if (this.selectedItems.length === 0) {
        this.$message({
          message: '请选择文件',
          type: 'success',
          center: true
        })
        return
      }
      let that = this
      if (this.valueType === 'content') {
        if (this.size === 1) {
          this.data = this.selectedItems[0].content
        } else {
          let value = []
          this.selectedItems.forEach(item => {
            value.push(item.content)
          })
          this.data = value
        }
      } else if (this.valueType === 'id') {
        if (this.size === 1) {
          this.data = this.selectedItems[0].id
        } else {
          let value = []
          this.selectedItems.forEach(item => {
            value.push(item.id)
          })
          this.data = value
        }
      } else {
        if (this.size === 1) {
          this.data = this.selectedItems[0]
        } else {
          this.data = this.selectedItems
        }
      }
      console.log('this.data change', this.data)
      this.$emit('change', this.data)
      this.show = false
    },
    delTag (fileId, tagId) {
      let that = this
      this.$confirm('确认去除标签', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delResourceTag(fileId, [tagId]).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {

        })
    },
    closeFileEdit () {
      this.fileEditShow = false
      this.getSearch(this.listQuery.currentPage)
    },
    viewFile (type, content) {
      this.viewFileType = type
      if (type === 6) {
        window.open(content)
      } else {
        this.viewFileContent = content
        this.viewFileShow = true
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val && typeof val === 'number') {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      fileResourceList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.list = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.fileEditShow = true
    },
    addDir () {
      this.addDirShow = true
    },
    addDirConfirm () {
      this.dirForm.pid = this.listQuery.categoryId
      addFileCategory(this.dirForm).then(res => {
        this.addDirShow = false
        this.getSearch()
        // that.$router.push("/demo/helper/keyword");
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delFileResource(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
        })
    }
  }
}
</script>
<style scoped>
.span {
    width: 50px;
    height: 50px;
    display: block;
    margin: 0px auto;
    border: 1px solid rgba(0, 0, 0, 0.3);
}

.selected-shadow {
    box-shadow: 0 2px 12px 0 rgb(224, 50, 50);
}

.cus-shadow:hover {
    box-shadow: 0 2px 12px 0 rgb(224, 50, 50);
}
.cus-shadow{
    position: relative;
}
.disabled{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色 */
    opacity: 0.5;

    z-index: 1000;
}

.footer{
    display: flex;
    padding-top: 40px;
    justify-content: center;
}
</style>
